// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Markdown-module--markdown--1JrJ2"};